import React, { Fragment } from 'react';
import { translate } from 'react-i18next';

import { Form } from 'common/components';
import { getFirstImage } from 'lib/assets/assets_helpers';
import { CUSTODY_NOTES_MAX_LENGTH } from 'schemas/assets_schemas';
import noimg from 'assets/img/noimg.gif';

const AssetFormGeneral = ({
  catalogs = {},
  errors = {},
  handleValueChange = () => {},
  isLoading = false,
  isSubmitted = false,
  t = () => {},
  asset_levels = [],
  values = {},
}) => {
  if (catalogs.prefix) {
    // console.log('%c ' + catalogs.prefix, 'background: #222; color: #bada55');
  }
  const renderFields = () => (
    <Fragment>
      {/* <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          autoFocus={true}
          error={(isSubmitted && errors.number) || {}}
          name={"number"}
          label={t("assets.fields.number") + " * "}
          handleChange={handleValueChange}
          t={t}
          value={values.number}
        />
      </div> */}
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          error={(isSubmitted && errors.serie) || {}}
          name={'serie'}
          label={t('assets.fields.serie')}
          handleChange={handleValueChange}
          t={t}
          value={values.serie}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          error={(isSubmitted && errors.name) || {}}
          name={'name'}
          label={t('assets.fields.name') + ' * '}
          handleChange={handleValueChange}
          t={t}
          value={values.name}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          error={(isSubmitted && errors.model) || {}}
          name={'model'}
          label={t('assets.fields.model')}
          handleChange={handleValueChange}
          t={t}
          value={values.model}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          error={(isSubmitted && errors.brand) || {}}
          name={'brand'}
          label={t('assets.fields.brand')}
          handleChange={handleValueChange}
          t={t}
          value={values.brand}
        />
      </div>
      {/* <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldSelect
          error={(isSubmitted && errors._prefix) || {}}
          isLoading={isLoading}
          name={"prefix"}
          label={t("assets.fields.prefix")}
          handleChange={handleValueChange}
          t={t}
          value={values._prefix && values._prefix.id}
        >
          {catalogs.prefix &&
            catalogs.prefix.map((element) => (
              <option value={element.id} key={element.id}>
                {t(element.value)}
              </option>
            ))}
        </Form.FieldSelect>
      </div> */}
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldSelect
          error={(isSubmitted && errors._physicalState) || {}}
          isLoading={isLoading}
          name={'physicalState'}
          label={t('assets.fields.physicalState')}
          handleChange={handleValueChange}
          t={t}
          value={values._physicalState && values._physicalState.id}
        >
          {catalogs.physicalState &&
            catalogs.physicalState
              .filter((element) => element != null)
              .map((element) => (
                <option value={element.id} key={element.id}>
                  {t(element.value)}
                </option>
              ))}
        </Form.FieldSelect>
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldDate
          error={(isSubmitted && errors.buyDate) || {}}
          isLoading={isLoading}
          name={'buyDate'}
          label={t('assets.fields.buyDate')}
          handleChange={handleValueChange}
          t={t}
          value={values.buyDate}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldSelect
          error={(isSubmitted && errors._country) || {}}
          isLoading={isLoading}
          name={'country'}
          label={t('assets.fields.country')}
          handleChange={handleValueChange}
          t={t}
          value={values._country && values._country.id}
        >
          {catalogs.country &&
            catalogs.country
              .filter((element) => element != null)
              .map((element) => (
                <option value={element.id} key={element.id}>
                  {t(element.value)}
                </option>
              ))}
        </Form.FieldSelect>
      </div>

      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldSelect
          error={(isSubmitted && errors._asset_level) || {}}
          isLoading={isLoading}
          name={'asset_level'}
          label={t('assets.fields.asset_level')}
          handleChange={handleValueChange}
          t={t}
          value={values._asset_level && values._asset_level.id}
        >
          {asset_levels &&
            asset_levels
              .filter((element) => element != null)
              .map((element) => (
                <option value={element.id} key={element.id}>
                  {t(element.name)}
                </option>
              ))}
        </Form.FieldSelect>
      </div>

      <div className="col-sm-12 mb-3">
        <Form.FieldTextArea
          error={(isSubmitted && errors.description) || {}}
          name={'description'}
          label={t('assets.fields.description')}
          handleChange={handleValueChange}
          t={t}
          value={values.description}
        />
      </div>

      <div className="col-sm-12 mb-3">
        <Form.FieldTextArea
          error={(isSubmitted && errors.custodyNotes) || {}}
          name={'custodyNotes'}
          label={t('assets.fields.custodyNotes')}
          placeholder={t('assets.fields.custodyNotesHelp')}
          handleChange={handleValueChange}
          t={t}
          value={values.custodyNotes}
          rows={4}
          maxLength={CUSTODY_NOTES_MAX_LENGTH}
        />
      </div>
    </Fragment>
  );

  const img = getFirstImage(values._files) || noimg;

  return (
    <div className="row mt-3 align-items-center bbottom">
      <div className="col-sm-12">
        <h5>
          <b>{t('assets.section.general')}</b>
        </h5>
        <br />
      </div>
      {values.id ? (
        <Fragment>
          <div className="col-sm-12 col-md-12 col-xl-12">
            <div className="row">{renderFields()}</div>
          </div>
          {/* <div className="col-sm-6 col-md-5  col-xl-4 text-center">
            {img && img.url ? (
              <a href={img.url} target="__brank">
                <img
                  src={img.url}
                  style={{ maxWidth: "70%", maxHeight: "200px" }}
                />
              </a>
            ) : (
                <img src={img} style={{ width: "70%" }} />
              )}
          </div> */}
        </Fragment>
      ) : (
        renderFields()
      )}
    </div>
  );
};

export default translate()(AssetFormGeneral);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetsFormGeneral.js